import './styles.scss'

import { useAppSelector } from '@/store/hook'
import { selectCartItems } from '@/store/selectors/cartSelector'
import useDummyItems from '@/hooks/useDummyItems'
import { isValidArray } from '@/libs/utils/array'

import CartItemMobile from '../CartItemMobile'

interface CartListMobileProps {
  isLoading?: boolean
}

const CartListMobile = ({ isLoading = false }: CartListMobileProps) => {
  const fakeProducts = useDummyItems()

  const cartItems = useAppSelector(selectCartItems)

  const renderListItems = () => {
    if (isLoading) {
      return fakeProducts.map((fakeProduct) => (
        <CartItemMobile
          key={fakeProduct?.materialNumber}
          cartItem={fakeProduct}
          isLoading={isLoading}
        />
      ))
    }

    return isValidArray(cartItems)
      ? cartItems.map((cartItem) => (
        <CartItemMobile
          key={cartItem?.materialNumber}
          cartItem={cartItem}
          isLoading={isLoading}
        />
      ))
      : null
  }

  return <div className="cart-table-mobile-wrapper">{renderListItems()}</div>
}

export default CartListMobile
